const payments = require('./payments');
const invoice = require('./implementations/invoice');
const wallet = require('./wallet');
const Loading = require('./implementations/payments/loading');
const Freight = require('./implementations/payments/freight');
const Deductibles = require('./implementations/payments/deductibles');

module.exports = { payments, invoice, wallet, Loading, Freight, Deductibles };
